import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";

export function MinimumQuantityField({
  value,
  setValue,
}: {
  value: number | undefined;
  setValue: (value: number | undefined) => void;
}) {
  return (
    <RedoTextInput
      fullWidth
      htmlPattern="^[0-9]*$"
      inputTypeHint="number"
      label="Minimum quantity of items bought"
      placeholder="0"
      setValue={(value) => {
        setValue(value ? Number(value) : undefined);
      }}
      value={value?.toString() ?? ""}
    />
  );
}
